module.exports = __webpack_public_path__ + "img/wilderness-park.49097286.png";